<template>
  <div>
    <v-expansion-panels multiple accordion>
      <v-expansion-panel
        v-for="produto in solicitacao.cotacaoConjunta.produtos"
        :key="produto.id"
      >
        <v-expansion-panel-header>
          <v-row no-gutters dense>
            <v-col cols="12" sm="10">
              <span class="body-1">
                {{ produto.id }} -
                {{ produto.produto.descricao }}
                <small class="caption">
                  ({{ produto.quantidadeParticipantes }} participante(s))
                </small>
              </span>
              <div class="body-2">
                <px-anexo read-only dot
                          v-model="produto.arquivos"
                          :download-base-path="downloadBasePath">
                </px-anexo>
                {{ produto.especificacaoProduto | naoInformado }}
                <px-produto-especificacao :especificacao="produto.especificacaoProduto"/>
              </div>
            </v-col>
            <v-col cols="12" sm="2" class="body-1">
              {{ produto.quantidade }} {{ produto.unidadeMedida.descricao }}
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div v-if="!solicitacao.grupoCompra.ocultarEmpresasFornecedor">
            <template v-for="participante in produto.participantes">
              <v-list-item :key="participante.id" class="body-2">
                <v-list-item-content>
                  <v-row no-gutters dense>
                    <v-col cols="12" sm="10">
                      {{ participante.comprador.pessoa.nome }}
                    </v-col>
                    <v-col cols="12" sm="2">
                      <span v-if="participante.quantidade">{{ participante.quantidade }}
                        {{ produto.unidadeMedida.descricao }}</span>
                    </v-col>
                    <v-list-item-subtitle>
                      {{ participante.comprador.pessoa.cnpj | cnpj }}
                      <px-regime-tributario
                        :regime-tributario="participante.comprador.pessoa.regimeTributario"/>
                    </v-list-item-subtitle>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
            </template>
          </div>
          <div v-else>
            <span class="body-2">
              O grupo de compras optou por ocultar os participantes da cotação.
            Caso sua proposta seja aprovada, você reberá a relação de participantes.
            </span>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
export default {
  props: {
    solicitacao: Object,
  },
  computed: {
    downloadBasePath() {
      return `/fornecedor/solicitacoes-respostas/${this.solicitacao.id}/file`;
    },
  },
};
</script>
